<template>

  <div class="profile-document-form">
    <b-modal :active.sync="showPreparingImageModal" :can-cancel="false">
      <div class="box flex">
        <div class="flex-1"><b>Preparing Image</b></div>
        <div><i class="fas fa-cog fa-spin"></i></div>
      </div>
    </b-modal>

    <b-modal :active.sync="showConfirmDeleteDocModal">
      <div class="box">
        <h1 class="title is-5">Deleting Document</h1>
        <div><b>Are you sure you want to delete this document?</b></div>
        <br />
        <div class="buttons">
          <button class="button is-danger" @click="deleteDoc">Confirm Delete</button>
          <button class="button" @click="showConfirmDeleteDocModal = false">Cancel</button>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="showAddOtherDetailModal">
      <div class="box" style="">
        <h1 class="title is-5">Add Other Detail</h1>
        <b-field label="Name">
          <b-input placeholder="detail name" v-model="otherDetailKey"></b-input>
        </b-field>
        <!-- <b-field label="Value">
          <b-input placeholder="detail value" v-model="otherDetailValue"></b-input>
        </b-field> -->
        <button class="button is-info" @click="addNewDetail">Add Detail</button>
      </div>
    </b-modal>

    <b-modal :active.sync="showUploadProgressModal" :can-cancel="false">
      <div class="box">
        <div class="flex">
          <h1 class="title is-5 flex-1">{{ saveStatus }}</h1>
          <div><i class="fas fa-cog fa-spin"></i></div>
        </div>
        <div class="box  image-upload" v-for="image in newImages" :key="image.id">
          <template v-if="image.url">
            <b>Uploaded</b> {{ image.name }}
            <progress class="progress is-info" :value="100" max="100">100</progress>
          </template>
          <template v-else-if="image.progress >= 0">
            <b>Uploading</b> {{ image.name }}
            <progress class="progress is-info" :value="image.progress" max="100"></progress>
          </template>
          <template v-else>
            <b>Queued</b> {{ image.name }}
            <progress class="progress is-info" value="0" max="0">0</progress>
          </template>
        </div>
      </div>
    </b-modal>

   <div class="columns">
      <div class="column">
        <div class="box">
          <b-field label="Name">
            <b-input placeholder="document name" v-model="doc.name"></b-input>
          </b-field>
          <b-field label="Number / ID #">
            <b-input placeholder="document identification number" v-model="doc.number"></b-input>
          </b-field>
        </div>
      </div>

      <div class="column">
        <div class="box">
          <b-field label="Issued Date">
            <b-datepicker
              v-model="dateIssued"
              icon-pack="fas"
              :mobile-native="false"
              placeholder="not set"
              icon="calendar-check">
              <div class="has-text-right">
                <button class="button is-small" @click.prevent="dateIssued = null">Clear</button>
                <button class="button is-primary is-small" @click.prevent="dateIssued = new Date()">Today</button>
              </div>
            </b-datepicker>
          </b-field>
          <b-field label="Expiry Date">
            <b-datepicker
              v-model="dateExpire"
              icon-pack="fas"
              :mobile-native="false"
              placeholder="not set"
              icon="calendar-check">
              <div class="has-text-right">
                <button class="button is-small" @click.prevent="dateIssued = null">Clear</button>
                <button class="button is-primary is-small" @click.prevent="dateIssued = new Date()">Today</button>
              </div>
            </b-datepicker>
          </b-field>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="box">
          <label class="label hoverable" @click="showAddOtherDetailModal = true">
            Other Document Details <i class="fas fa-plus is-success"></i>
          </label>

          <div class="field is-horizontal" v-for="(detail, index) in doc.otherDetails" :key="index">
            <div class="field-label is-normal">
              <label class="label">{{ detail.key }}</label>
            </div>
            <div class="field-body">
              <div class="field is-grouped">
                <p class="control is-expanded">
                  <input class="input" type="text" v-model="detail.value">
                </p>
                 <p class="control">
                   <button class="button is-danger" @click="doc.otherDetails.splice(index, 1)">
                     <i class="fas fa-times"></i>
                   </button>
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">

        <template v-if="doc.images.length">
          <label class="label hoverable">
            Images
          </label>
          <div class="columns is-multiline">
            <div v-for="(image, index) in doc.images" :key="image.id" class="column is-3">
              <div class="box is-small has-text-right">
                <div class="flex">
                  <div class="flex-1" style="padding-right: 5px;">
                    <b-input placeholder="Image name" size="is-small" v-model="image.name"></b-input>
                  </div>
                  <button class="button is-danger is-small" @click="removeImage(index)">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
                <img style="width: 100%; margin: 5px 0 0 0" :src="image.url">
              </div>
            </div>
          </div>
        </template>

        <hr v-if="doc.images.length && newImages.length" />

        <label class="label hoverable" for="file-upload">
          Add Image <i class="fas fa-plus is-success"></i>
        </label>
        <input ref="fileInput" id="file-upload" type="file" accept="image/*">

          <div class="columns is-multiline">
          <div v-for="(image, index) in newImages" :key="image.id" class="column is-3">
            <div class="box is-small has-text-right">
              <div class="flex">
                <div class="flex-1"  style="padding-right: 5px;">
                  <b-input placeholder="Image name" size="is-small" v-model="image.name"></b-input>
                </div>
                <button class="button is-danger is-small" @click="newImages.splice(index, 1)">
                  <i class="fas fa-times"></i>
                </button>
              </div>
              <img style="width: 100%; margin: 5px 0 0 0" :src="image.dataUrl">
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column is-8">
        <div class="buttons">
          <button class="button is-info" :class="{'is-loading': loading}" @click.prevent="submitDocument">submit</button>
          <button v-if="showCancel" class="button" @click="$emit('cancel')">cancel</button>
        </div>
      </div>
      <div class="column is-4 has-text-right">
        <button v-if="doc._id" class="button is-danger" @click="showConfirmDeleteDocModal = true">Delete</button>
      </div>
    </div>

  </div>

</template>

<style>
  .profile-document-form input[type="file"] {
    display: none;
  }
</style>

<script>
import firebase from 'firebase/app'
import 'firebase/storage'

export default {
  name: 'ProfileDocumentForm',
  props: {
    doc: {
      default () {
        return {
          name: '',
          number: '',
          dateIssued: null,
          dateExpire: null,
          images: [],
          otherDetails: []
        }
      }
    },
    user: { required: true },
    showCancel: { default: false }
  },
  data () {
    return {
      newImages: [],
      toDeleteImages: [],
      loading: false,
      dateIssued: null,
      dateExpire: null,
      showUploadProgressModal: false,
      showAddOtherDetailModal: false,
      showConfirmDeleteDocModal: false,
      showPreparingImageModal: false,
      otherDetailKey: '',
      otherDetailValue: '',
      saveStatus: ''
    }
  },
  watch: {
    doc () {
      this.prepareDoc()
    }
  },
  created () {
    console.log('ProfileDoducmentForm component created!')
  },
  mounted () {
    this.$refs.fileInput.addEventListener('change', this.fileChanged, false)
    this.prepareDoc()
  },
  methods: {
    prepareDoc () {
      console.log('prepareDoc', this.doc)
      if (this.doc.dateIssued) {
        this.dateIssued = this.$moment.unix(this.doc.dateIssued).toDate()
      }
      if (this.doc.dateExpire) {
        this.dateExpire = this.$moment.unix(this.doc.dateExpire).toDate()
      }
    },
    addNewDetail (detail) {
      this.otherDetailKey = this.otherDetailKey.trim()
      if (this.otherDetailKey.length) {
        this.doc.otherDetails.push({ key: this.otherDetailKey, value: this.otherDetailValue })
        this.otherDetailKey = ''
        this.otherDetailValue = ''
      }
      this.showAddOtherDetailModal = false
    },
    removeImage (index) {
      this.toDeleteImages.push(this.doc.images[index])
      this.doc.images.splice(index, 1)
    },
    submitDocument () {
      this.saveStatus = 'Saving document data'
      this.showUploadProgressModal = true
      this.doc.dateIssued = this.dateIssued ? this.$moment(this.dateIssued).endOf('day').unix() : 0
      this.doc.dateExpire = this.dateExpire ? this.$moment(this.dateExpire).endOf('day').unix() : 0

      let docId = this.doc._id
      if (docId) {
        this.saveStatus = 'Updating document data'
        this.$firestore.collection('profile-documents')
          .doc(docId)
          .set(this.doc)
          .then(() => {
            this.uploadImages(docId)
          })
      } else {
        this.doc.uid = this.user.uid
        this.$firestore.collection('profile-documents')
          .add(this.doc)
          .then(docRef => {
            this.doc._id = docRef.id
            this.uploadImages(docRef.id)
          })
      }
    },
    uploadImages (docId) {
      if (!this.newImages || !this.newImages.length) {
        this.deleteImages(this.doc.images)
          .then(this.submitComplete)
        return
      }
      this.saveStatus = 'Uploading Images'
      let i = 0
      let dequeueUpload = () => {
        let image = this.newImages[i]
        this.uploadFile(image)
          .then(res => {
            if (res) {
              image.url = res
              delete image.dataUrl
              delete image.progress
              this.doc.images.push(image)
            }
            i++
            if (i < this.newImages.length) {
              dequeueUpload()
            } else {
              this.$firestore.collection('profile-documents')
                .doc(docId)
                .update({ images: this.doc.images })
                .then(() => this.deleteImages(this.toDeleteImages))
                .then(this.submitComplete)
            }
          })
      }
      dequeueUpload()
    },
    deleteImages (images) {
      return new Promise((resolve, reject) => {
        if (!images || !images.length) {
          resolve()
          return
        }
        this.saveStatus = 'Deleting images'
        let storageRef = firebase.storage().ref()
        let index = 0
        let dequeImage = () => {
          storageRef.child(images[index].id).delete()
            .then(() => {
              index++
              if (index < images.length) {
                dequeImage()
              } else {
                resolve()
              }
            })
            .catch(reject)
        }
        dequeImage()
      })
    },
    submitComplete () {
      this.saveStatus = 'Complete'
      this.newImages = []
      this.toDeleteImages = []
      this.showUploadProgressModal = false
      this.showConfirmDeleteDocModal = false
      this.$emit('submitted', this.doc)
      console.log('SUBMIT COMPLETE')
    },
    fileChanged () {
      if (!this.$refs.fileInput.files.length) {
        return
      }
      this.showPreparingImageModal = true
      let file = this.$refs.fileInput.files[0]

      let fileReader = new FileReader()
      fileReader.onload = (e) => {
        this.newImages.push({
          name: file.name,
          id: `profile-documents/image-${Number(new Date())}`,
          url: false,
          dataUrl: e.target.result,
          progress: -1
        })
        this.$refs.fileInput.value = null
        this.showPreparingImageModal = false
      }
      fileReader.readAsDataURL(file)
    },
    uploadFile (file) {
      return new Promise(resolve => {
        if (!file.dataUrl) {
          resolve(false)
          return
        }
        this.uploading = true
        let storageRef = firebase.storage().ref()
        let uploadTask = storageRef.child(file.id).putString(file.dataUrl, 'data_url')
        file.progress = 0
        uploadTask.on('state_changed',
          (snapshot) => {
            file.progress = ((snapshot.bytesTransferred / snapshot.totalBytes) * 100).toFixed(0)
          },
          (error) => {
            switch (error.code) {
              case 'storage/unauthorized':
                console.error('UPLOAD UNAUTHORIZED')
                break
              case 'storage/canceled':
                console.warn('UPLOAD CANCELLED')
                break
              case 'storage/unknown':
                console.error('UPLOAD UNKNOWN ERROR')
                break
            }
            resolve(false)
          },
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then(resolve)
          })
      })
    },
    deleteDoc () {
      this.showConfirmDeleteDocModal = false
      this.showUploadProgressModal = true
      this.deleteImages(JSON.parse(JSON.stringify(this.doc.images)))
        .then(() => {
          this.saveStatus = 'Deleting Document'
          this.$firestore.collection('profile-documents').doc(this.doc._id).delete()
            .then(resp => {
              this.submitComplete()
            })
            .catch(err => {
              console.error('delete doc', err)
              this.submitComplete()
            })
        })
        .catch(err => {
          console.error('deleteImages', err)
          this.saveStatus = 'Deleting Document'
          this.$firestore.collection('profile-documents').doc(this.doc._id).delete()
            .then(resp => {
              this.submitComplete()
            })
            .catch(err => {
              console.error('delete doc', err)
              this.submitComplete()
            })
        })
    }
  }
}
</script>
